<!--
 * @Author: chengleilei
 * @Date: 2026-02-06 14:16:37
 * @Description: 公共资源库审核记录tab
-->
<template>
    <div class="pub-autid-record" v-loading="pageLoading">
        <Card v-for="item in list" :key="item.id" style="width: 500px" dis-hover class="mb-16">
            <p>{{ item.auditDate }}</p>
            <Row>
                <Col span="12">审核人：{{ item.auditOperator }}</Col>
                <Col span="12">审核结果：{{ ['', '待审核', '驳回', '通过'][item.auditStatus] }}</Col>
            </Row>
            <p v-if="item.auditReason">驳回理由：{{ item.auditReason }}</p>
        </Card>
        <div v-if="list.length < 1" class="no-data">- 无公共资源库审核记录 -</div>
    </div>
</template>
<script>
import { apiPubAuditList } from '@/api/store';

export default {
    data() {
        return {
            id: this.$route.query.id || '',
            pageLoading: false,
            list: [],
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        // 查询公共资源库审核记录
        async getData() {
            const params = { storeId: this.id };
            try {
                const res = await apiPubAuditList(params);
                this.list = res.records || [];
                this.pageLoading = true;
            } finally {
                this.pageLoading = true;
            }
        },
    },
};
</script>
<style lang="less" scoped>
.pub-autid-record {
    .no-data {
        line-height: 170px;
        width: 100%;
        text-align: center;
    }
}
</style>
